module.exports = __webpack_public_path__ + "0af882c5189b65b176c415a2e0beb25e.woff";